import api from '../../api/axios';
import { showError, showSuccess } from '../../Components/reuse/Toast';

// Action Types: Global Voice Prompt Settings
export const SAVE_GLOBAL_VOICE_PROMPT_REQUEST = 'SAVE_GLOBAL_VOICE_PROMPT_REQUEST';
export const SAVE_GLOBAL_VOICE_PROMPT_SUCCESS = 'SAVE_GLOBAL_VOICE_PROMPT_SUCCESS';
export const SAVE_GLOBAL_VOICE_PROMPT_FAILURE = 'SAVE_GLOBAL_VOICE_PROMPT_FAILURE';

// POST: voiceAgent/globalVoicePromptSettings
export const saveGlobalVoicePrompt = (prompt, type = 'voiceprompt') => async (dispatch) => {
  dispatch({ type: SAVE_GLOBAL_VOICE_PROMPT_REQUEST });
  try {
    const response = await api.post('voiceAgent/globalVoicePromptSettings', { prompt, type });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: SAVE_GLOBAL_VOICE_PROMPT_SUCCESS, payload: response.data });
      if (response?.data?.message) {
        showSuccess(response.data.message);
      }
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to save global voice prompt';
    dispatch({ type: SAVE_GLOBAL_VOICE_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to save global voice prompt';
    dispatch({ type: SAVE_GLOBAL_VOICE_PROMPT_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};

